/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('PrivacyController', PrivacyController);

    PrivacyController.$inject = ['$scope'];

    function PrivacyController ($scope) {
        var vm = this;
    }
})();
